define('lq/events/actions/confirmEmailMfaCommand',[
    'jquery',
    'lq',
    'lq/events/actions/eventAction'
], function ($, lq, EventAction) {
    'use strict';

    function ConfirmEmailMfaCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(ConfirmEmailMfaCommand, EventAction);
    ConfirmEmailMfaCommand.typeName = 'ConfirmEmailMfaCommand';

    ConfirmEmailMfaCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ConfirmEmailMfaCommand.prototype.execute = function (continuation) {
        var queryString = this.piping.queryString;
        var values = {
            id: queryString.getValueOf('mfaId'),
            token: queryString.getValueOf('mfaToken'),
            actionId: queryString.getValueOf('mfaActionId'),
            commandId: queryString.getValueOf('mfaCommandId'),
            __RequestVerificationToken: this.piping.dispatcher.csrfToken,
            ajax: true
        };

        if (!values.id || !values.token || !values.actionId || !values.commandId) {
            this.handleError('invalid_url', 'Open this page using the confirmation link in your MFA email.', continuation);
            return;
        }

        if (!values.__RequestVerificationToken) {
            this.handleError('request_failed', 'The confirmation page could not be verified. Please reload the page and try again.', continuation);
            return;
        }

        var self = this;
        this.piping.busyIndicator.show();
        // Form-encoded AJAX lets both MVC versions validate the anti-forgery token.
        // Do not automatically retry a request that may already have confirmed a one-time token.
        $.ajax({
            url: lq.getTenantUrl('Mfa/ConfirmEmail'),
            type: 'POST',
            data: values,
            dataType: 'json',
            global: false
        }).always(function () {
            self.piping.busyIndicator.hide();
        }).done(function (result) {
            var eventName = result.success ? 'success' : 'failed';
            if (self.hasEventHandler(eventName)) {
                self.triggerEvent(eventName, continuation, result.failureCode);
            } else {
                self.redirectTo(result.redirectUrl || lq.getTenantUrl('Mfa/ConfirmationResult'));
            }
        }).fail(function () {
            self.handleError('request_failed', 'Unable to confirm your sign-in. Please try again.', continuation);
        });
    };

    ConfirmEmailMfaCommand.prototype.hasEventHandler = function (eventName) {
        return this.eventIsEnabled(eventName) && this.eventData.eventing[eventName].raisedEventName;
    };

    ConfirmEmailMfaCommand.prototype.handleError = function (failureCode, message, continuation) {
        if (this.hasEventHandler('failed')) {
            this.triggerEvent('failed', continuation, failureCode);
        } else {
            alert(message);
            continuation({ break: true });
        }
    };

    ConfirmEmailMfaCommand.prototype.redirectTo = function (url) {
        window.location.href = url;
    };

    return ConfirmEmailMfaCommand;
});

